export const ROOT = '/BackgroundCheck';
export const EMAILPREVIEWROOT = '/EmailPreviewAPI';
export const LIST = `${ROOT}/getbcheckbypage`;
export const EXPORT = `${ROOT}/export`;
export const APPROVAL = `${ROOT}/approval`;
export const GET_APPLICANT_DETAIL = `${ROOT}/GetApplicantLatestDetail`;
export const SEND_EMAIL_NOTIF = `${ROOT}/sendEmailNotificationToCharRef`;
export const GET_BACKGROUND_CHECK_DETAIL_EMAIL_PREVIEW = `${EMAILPREVIEWROOT}/getbackgroundcheckdetailemail`;
export const UPDATE_BACKGROUND_CHECK_DETAIL_WITH_EMAIL = `${ROOT}/updatebackgroundcheckdetailwithemail`;